var _g, _g2, _path, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstagramCaptions(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 62,
    viewBox: "0 0 60 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1035_7719)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 4,
    width: 48,
    height: 48,
    rx: 10,
    fill: "url(#paint0_linear_1035_7719)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter1_f_1035_7719)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.13037 11.7218C10.6956 9.63485 12.7825 5.46094 21.6509 5.46094C29.0935 5.46094 33.7326 5.46094 39.3271 5.46094C44.9217 5.46094 49.4086 8.41746 50.9738 11.7218",
    stroke: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.8503 16H25.1497C21.2074 16 18 19.2074 18 23.1497V32.8503C18 36.7926 21.2074 40 25.1497 40H34.8503C38.7926 40 42 36.7926 42 32.8503V23.1497C42 19.2074 38.7926 16 34.8503 16ZM39.5856 32.8503C39.5856 35.4655 37.4655 37.5856 34.8503 37.5856H25.1497C22.5345 37.5856 20.4144 35.4655 20.4144 32.8503V23.1497C20.4144 20.5345 22.5345 18.4144 25.1497 18.4144H34.8503C37.4655 18.4144 39.5856 20.5345 39.5856 23.1497V32.8503Z",
    fill: "white",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0007 21.7927C26.578 21.7927 23.7935 24.5773 23.7935 27.9999C23.7935 31.4226 26.578 34.2072 30.0007 34.2072C33.4234 34.2072 36.208 31.4226 36.208 27.9999C36.208 24.5772 33.4234 21.7927 30.0007 21.7927ZM30.0007 31.7928C27.906 31.7928 26.2079 30.0947 26.2079 28C26.2079 25.9052 27.906 24.2071 30.0007 24.2071C32.0955 24.2071 33.7936 25.9052 33.7936 28C33.7936 30.0947 32.0954 31.7928 30.0007 31.7928Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2188 23.3267C37.0402 23.3267 37.7061 22.6608 37.7061 21.8394C37.7061 21.018 37.0402 20.3521 36.2188 20.3521C35.3974 20.3521 34.7314 21.018 34.7314 21.8394C34.7314 22.6608 35.3974 23.3267 36.2188 23.3267Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1035_7719",
    x: 0,
    y: 2,
    width: 60,
    height: 60,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.594121 0 0 0 0 0.255313 0 0 0 0 0.7125 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1035_7719"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1035_7719",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_1035_7719",
    x: 4.73047,
    y: 0.960938,
    width: 50.6953,
    height: 15.0608,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_1035_7719"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1035_7719",
    x1: 30,
    y1: 4,
    x2: 30,
    y2: 52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.173913,
    stopColor: "#6775F8",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A67F8"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramCaptions);
export default __webpack_public_path__ + "static/media/instagram-captions.63f6c391d9221877940b9daf7bec46ce.svg";
export { ForwardRef as ReactComponent };